/*
 * <scroll-rail> -- shared maap.cc-style scroll indicator for horizontal sliders.
 *
 * Markup contract:
 *   <scroll-rail>
 *     <ul data-scroll-rail-track> ... </ul>          {# the scrollable element #}
 *     {% render 'scroll-rail-bar' %}                  {# .scroll-rail__bar + __thumb #}
 *   </scroll-rail>
 *
 * The thumb width reflects the visible proportion of the track and slides as it
 * scrolls. The bar is hidden until the track actually overflows, so the same
 * element works for mobile-only sliders and desktop scrollers alike.
 */
if (!customElements.get('scroll-rail')) {
  customElements.define(
    'scroll-rail',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-scroll-rail-track]');
        this.bar = this.querySelector('.scroll-rail__bar');
        this.thumb = this.querySelector('.scroll-rail__thumb');
        if (!this.track || !this.bar || !this.thumb) return;

        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.update);
          this.ro.observe(this.track);
        } else {
          window.addEventListener('resize', this.update);
          this.update();
        }
      }

      disconnectedCallback() {
        if (this.ro) this.ro.disconnect();
      }

      // Reveal the rail only when the track overflows. Thumb width = visible
      // proportion; thumb offset = scroll progress across the remaining overflow.
      update() {
        const { scrollWidth, clientWidth, scrollLeft } = this.track;
        const overflow = scrollWidth - clientWidth;

        if (overflow <= 1) {
          this.bar.style.display = 'none';
          return;
        }

        this.bar.style.display = 'block';
        const ratio = clientWidth / scrollWidth;
        const progress = scrollLeft / overflow;
        this.thumb.style.width = ratio * 100 + '%';
        this.thumb.style.left = (1 - ratio) * progress * 100 + '%';
      }
    }
  );
}
